// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v3/payment_link.proto

/* eslint-disable */
import { ApiCurrencyAmount } from "../../../../common/payment";

/** Enum for payment link status */
export const ApiPaymentLinkStatus = {
  /** PAYMENT_LINK_STATUS_UNSPECIFIED - Default unspecified value for unknown or unrecognized status */
  PAYMENT_LINK_STATUS_UNSPECIFIED: "PAYMENT_LINK_STATUS_UNSPECIFIED",
  /**
   * Payment link is open for payments
   */
  open: "open",
  /**
   * Payment link is processing
   */
  processing: "processing",
  /**
   * Payment link has been paid
   */
  paid: "paid",
  /**
   * Payment link has expired
   */
  expired: "expired",
  /**
   * Payment link has been canceled
   */
  canceled: "canceled",
} as const;

export type ApiPaymentLinkStatus = typeof ApiPaymentLinkStatus[keyof typeof ApiPaymentLinkStatus];

export namespace ApiPaymentLinkStatus {
  export type PAYMENT_LINK_STATUS_UNSPECIFIED = typeof ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
  export type open = typeof ApiPaymentLinkStatus.open;
  export type processing = typeof ApiPaymentLinkStatus.processing;
  export type paid = typeof ApiPaymentLinkStatus.paid;
  export type expired = typeof ApiPaymentLinkStatus.expired;
  export type canceled = typeof ApiPaymentLinkStatus.canceled;
}

export function apiPaymentLinkStatusFromJSON(object: any): ApiPaymentLinkStatus {
  switch (object) {
    case 0:
    case "PAYMENT_LINK_STATUS_UNSPECIFIED":
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
    case 1:
    case "open":
      return ApiPaymentLinkStatus.open;
    case 2:
    case "processing":
      return ApiPaymentLinkStatus.processing;
    case 3:
    case "paid":
      return ApiPaymentLinkStatus.paid;
    case 4:
    case "expired":
      return ApiPaymentLinkStatus.expired;
    case 5:
    case "canceled":
      return ApiPaymentLinkStatus.canceled;
    default:
      return ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED;
  }
}

export function apiPaymentLinkStatusToJSON(object: ApiPaymentLinkStatus): string {
  switch (object) {
    case ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED:
      return "PAYMENT_LINK_STATUS_UNSPECIFIED";
    case ApiPaymentLinkStatus.open:
      return "open";
    case ApiPaymentLinkStatus.processing:
      return "processing";
    case ApiPaymentLinkStatus.paid:
      return "paid";
    case ApiPaymentLinkStatus.expired:
      return "expired";
    case ApiPaymentLinkStatus.canceled:
      return "canceled";
    default:
      return "PAYMENT_LINK_STATUS_UNSPECIFIED";
  }
}

/** Enum for payment methods */
export const ApiPaymentMethod = {
  /** PAYMENT_METHOD_UNSPECIFIED - Default unspecified value for unknown or unrecognized payment method */
  PAYMENT_METHOD_UNSPECIFIED: "PAYMENT_METHOD_UNSPECIFIED",
  /**
   * Credit card payment method
   */
  credit_card: "credit_card",
  /**
   * Apple Pay payment method
   */
  apple_pay: "apple_pay",
  /**
   * PayPal payment method
   */
  paypal: "paypal",
  /**
   * iDEAL payment method
   */
  ideal: "ideal",
  /**
   * Bank transfer payment method
   */
  bank_transfer: "bank_transfer",
} as const;

export type ApiPaymentMethod = typeof ApiPaymentMethod[keyof typeof ApiPaymentMethod];

export namespace ApiPaymentMethod {
  export type PAYMENT_METHOD_UNSPECIFIED = typeof ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  export type credit_card = typeof ApiPaymentMethod.credit_card;
  export type apple_pay = typeof ApiPaymentMethod.apple_pay;
  export type paypal = typeof ApiPaymentMethod.paypal;
  export type ideal = typeof ApiPaymentMethod.ideal;
  export type bank_transfer = typeof ApiPaymentMethod.bank_transfer;
}

export function apiPaymentMethodFromJSON(object: any): ApiPaymentMethod {
  switch (object) {
    case 0:
    case "PAYMENT_METHOD_UNSPECIFIED":
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
    case 1:
    case "credit_card":
      return ApiPaymentMethod.credit_card;
    case 2:
    case "apple_pay":
      return ApiPaymentMethod.apple_pay;
    case 3:
    case "paypal":
      return ApiPaymentMethod.paypal;
    case 4:
    case "ideal":
      return ApiPaymentMethod.ideal;
    case 5:
    case "bank_transfer":
      return ApiPaymentMethod.bank_transfer;
    default:
      return ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  }
}

export function apiPaymentMethodToJSON(object: ApiPaymentMethod): string {
  switch (object) {
    case ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED:
      return "PAYMENT_METHOD_UNSPECIFIED";
    case ApiPaymentMethod.credit_card:
      return "credit_card";
    case ApiPaymentMethod.apple_pay:
      return "apple_pay";
    case ApiPaymentMethod.paypal:
      return "paypal";
    case ApiPaymentMethod.ideal:
      return "ideal";
    case ApiPaymentMethod.bank_transfer:
      return "bank_transfer";
    default:
      return "PAYMENT_METHOD_UNSPECIFIED";
  }
}

/** Enum for resource type */
export const ApiResourceType = {
  /** RESOURCE_TYPE_UNSPECIFIED - Default unspecified value for unknown or unrecognized resource type */
  RESOURCE_TYPE_UNSPECIFIED: "RESOURCE_TYPE_UNSPECIFIED",
  /**
   * Basket resource type
   */
  Basket: "Basket",
  /**
   * Invoice resource type
   */
  Invoice: "Invoice",
} as const;

export type ApiResourceType = typeof ApiResourceType[keyof typeof ApiResourceType];

export namespace ApiResourceType {
  export type RESOURCE_TYPE_UNSPECIFIED = typeof ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
  export type Basket = typeof ApiResourceType.Basket;
  export type Invoice = typeof ApiResourceType.Invoice;
}

export function apiResourceTypeFromJSON(object: any): ApiResourceType {
  switch (object) {
    case 0:
    case "RESOURCE_TYPE_UNSPECIFIED":
      return ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
    case 1:
    case "Basket":
      return ApiResourceType.Basket;
    case 2:
    case "Invoice":
      return ApiResourceType.Invoice;
    default:
      return ApiResourceType.RESOURCE_TYPE_UNSPECIFIED;
  }
}

export function apiResourceTypeToJSON(object: ApiResourceType): string {
  switch (object) {
    case ApiResourceType.RESOURCE_TYPE_UNSPECIFIED:
      return "RESOURCE_TYPE_UNSPECIFIED";
    case ApiResourceType.Basket:
      return "Basket";
    case ApiResourceType.Invoice:
      return "Invoice";
    default:
      return "RESOURCE_TYPE_UNSPECIFIED";
  }
}

/** Enum for item type */
export const ApiItemType = {
  /** ITEM_TYPE_UNSPECIFIED - Default unspecified value for unknown or unrecognized item type */
  ITEM_TYPE_UNSPECIFIED: "ITEM_TYPE_UNSPECIFIED",
  /**
   * Good item type
   */
  good: "good",
  /**
   * Service item type
   */
  service: "service",
} as const;

export type ApiItemType = typeof ApiItemType[keyof typeof ApiItemType];

export namespace ApiItemType {
  export type ITEM_TYPE_UNSPECIFIED = typeof ApiItemType.ITEM_TYPE_UNSPECIFIED;
  export type good = typeof ApiItemType.good;
  export type service = typeof ApiItemType.service;
}

export function apiItemTypeFromJSON(object: any): ApiItemType {
  switch (object) {
    case 0:
    case "ITEM_TYPE_UNSPECIFIED":
      return ApiItemType.ITEM_TYPE_UNSPECIFIED;
    case 1:
    case "good":
      return ApiItemType.good;
    case 2:
    case "service":
      return ApiItemType.service;
    default:
      return ApiItemType.ITEM_TYPE_UNSPECIFIED;
  }
}

export function apiItemTypeToJSON(object: ApiItemType): string {
  switch (object) {
    case ApiItemType.ITEM_TYPE_UNSPECIFIED:
      return "ITEM_TYPE_UNSPECIFIED";
    case ApiItemType.good:
      return "good";
    case ApiItemType.service:
      return "service";
    default:
      return "ITEM_TYPE_UNSPECIFIED";
  }
}

/** Message for payment initiator information */
export interface ApiPaymentInitiator {
  /** Resource ID */
  readonly resourceId: string;
  /** Resource type */
  readonly resourceType: string;
  /** Resource number (can be null) */
  readonly resourceNumber?: string | null | undefined;
}

/** Message for payment link settings */
export interface ApiPaymentLinkSettings {
  /** URL to redirect to after payment */
  readonly redirectUrl?:
    | string
    | null
    | undefined;
  /** Whether the payment link is reusable */
  readonly reusable: boolean;
}

/** Message for payment link item */
export interface ApiPaymentLinkItem {
  /** Item ID */
  readonly id?:
    | string
    | null
    | undefined;
  /** Item title */
  readonly title: string;
  /** Item type */
  readonly type?:
    | string
    | null
    | undefined;
  /** Item description */
  readonly description?:
    | string
    | null
    | undefined;
  /** Item quantity */
  readonly quantity: number;
  /** Measurement unit */
  readonly measureUnit?:
    | string
    | null
    | undefined;
  /** Unit price */
  readonly unitPrice:
    | ApiCurrencyAmount
    | null;
  /** VAT rate */
  readonly vatRate: string;
}

/** Message for payment link attributes */
export interface ApiPaymentLinkAttributes {
  /** Payment amount */
  readonly amount:
    | ApiCurrencyAmount
    | null;
  /** Latest payment method used (can be null) */
  readonly latestPaymentMethod?:
    | string
    | null
    | undefined;
  /** Debitor name (can be null) */
  readonly debitorName?:
    | string
    | null
    | undefined;
  /** Payment initiator information */
  readonly paymentInitiator:
    | ApiPaymentInitiator
    | null;
  /** Payment link status */
  readonly status: string;
  /** List of potential payment methods */
  readonly potentialPaymentMethods: readonly string[];
  /** Payment link settings (can be null) */
  readonly settings?:
    | ApiPaymentLinkSettings
    | null
    | undefined;
  /** Expiration date */
  readonly expirationDate: string;
  /** Organization name (can be null) */
  readonly organizationName?:
    | string
    | null
    | undefined;
  /** Payment link name */
  readonly name: string;
  /** Creation timestamp */
  readonly createdAt: string;
  /** Payment link items */
  readonly items: readonly ApiPaymentLinkItem[];
}

/** Message for payment link */
export interface ApiPaymentLink {
  /** Payment link ID */
  readonly id: string;
  /** Resource type (always "payment_links") */
  readonly type: string;
  /** Payment link attributes */
  readonly attributes: ApiPaymentLinkAttributes | null;
}

/** Message for pagination metadata */
export interface ApiMeta {
  /** Total number of records (DEPRECATED, use total_count instead) */
  readonly total: number;
  /** Total count of records */
  readonly totalCount: number;
  /** Next page number */
  readonly nextPage: number;
  /** Previous page number */
  readonly prevPage: number;
  /** Total number of pages */
  readonly totalPages: number;
  /** Current page number */
  readonly currentPage: number;
  /** Records per page */
  readonly perPage: number;
}

export const ApiPaymentInitiator: MessageFns<ApiPaymentInitiator> = {
  fromJSON(object: any): ApiPaymentInitiator {
    return {
      resourceId: isSet(object.resource_id) ? globalThis.String(object.resource_id) : "",
      resourceType: isSet(object.resource_type) ? globalThis.String(object.resource_type) : "",
      resourceNumber: isSet(object.resource_number) ? globalThis.String(object.resource_number) : null,
    };
  },

  toJSON(message: ApiPaymentInitiator): unknown {
    const obj: any = {};
    if (message.resourceId !== "") {
      obj.resource_id = message.resourceId;
    }
    if (message.resourceType !== "") {
      obj.resource_type = message.resourceType;
    }
    if (message.resourceNumber !== undefined && message.resourceNumber !== null) {
      obj.resource_number = message.resourceNumber;
    }
    return obj;
  },
};

export const ApiPaymentLinkSettings: MessageFns<ApiPaymentLinkSettings> = {
  fromJSON(object: any): ApiPaymentLinkSettings {
    return {
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : null,
      reusable: isSet(object.reusable) ? globalThis.Boolean(object.reusable) : false,
    };
  },

  toJSON(message: ApiPaymentLinkSettings): unknown {
    const obj: any = {};
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.reusable !== false) {
      obj.reusable = message.reusable;
    }
    return obj;
  },
};

export const ApiPaymentLinkItem: MessageFns<ApiPaymentLinkItem> = {
  fromJSON(object: any): ApiPaymentLinkItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : null,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : null,
      description: isSet(object.description) ? globalThis.String(object.description) : null,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      measureUnit: isSet(object.measure_unit) ? globalThis.String(object.measure_unit) : null,
      unitPrice: isSet(object.unit_price) ? ApiCurrencyAmount.fromJSON(object.unit_price) : null,
      vatRate: isSet(object.vat_rate) ? globalThis.String(object.vat_rate) : "",
    };
  },

  toJSON(message: ApiPaymentLinkItem): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = message.type;
    }
    if (message.description !== undefined && message.description !== null) {
      obj.description = message.description;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.measureUnit !== undefined && message.measureUnit !== null) {
      obj.measure_unit = message.measureUnit;
    }
    if (message.unitPrice !== undefined && message.unitPrice !== null) {
      obj.unit_price = ApiCurrencyAmount.toJSON(message.unitPrice);
    }
    if (message.vatRate !== "") {
      obj.vat_rate = message.vatRate;
    }
    return obj;
  },
};

export const ApiPaymentLinkAttributes: MessageFns<ApiPaymentLinkAttributes> = {
  fromJSON(object: any): ApiPaymentLinkAttributes {
    return {
      amount: isSet(object.amount) ? ApiCurrencyAmount.fromJSON(object.amount) : null,
      latestPaymentMethod: isSet(object.latest_payment_method) ? globalThis.String(object.latest_payment_method) : null,
      debitorName: isSet(object.debitor_name) ? globalThis.String(object.debitor_name) : null,
      paymentInitiator: isSet(object.payment_initiator) ? ApiPaymentInitiator.fromJSON(object.payment_initiator) : null,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      potentialPaymentMethods: globalThis.Array.isArray(object?.potential_payment_methods)
        ? object.potential_payment_methods.map((e: any) => globalThis.String(e))
        : [],
      settings: isSet(object.settings) ? ApiPaymentLinkSettings.fromJSON(object.settings) : null,
      expirationDate: isSet(object.expiration_date) ? globalThis.String(object.expiration_date) : "",
      organizationName: isSet(object.organization_name) ? globalThis.String(object.organization_name) : null,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdAt: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ApiPaymentLinkItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiPaymentLinkAttributes): unknown {
    const obj: any = {};
    if (message.amount !== undefined && message.amount !== null) {
      obj.amount = ApiCurrencyAmount.toJSON(message.amount);
    }
    if (message.latestPaymentMethod !== undefined && message.latestPaymentMethod !== null) {
      obj.latest_payment_method = message.latestPaymentMethod;
    }
    if (message.debitorName !== undefined && message.debitorName !== null) {
      obj.debitor_name = message.debitorName;
    }
    if (message.paymentInitiator !== undefined && message.paymentInitiator !== null) {
      obj.payment_initiator = ApiPaymentInitiator.toJSON(message.paymentInitiator);
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.potentialPaymentMethods?.length) {
      obj.potential_payment_methods = message.potentialPaymentMethods;
    }
    if (message.settings !== undefined && message.settings !== null) {
      obj.settings = ApiPaymentLinkSettings.toJSON(message.settings);
    }
    if (message.expirationDate !== "") {
      obj.expiration_date = message.expirationDate;
    }
    if (message.organizationName !== undefined && message.organizationName !== null) {
      obj.organization_name = message.organizationName;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.createdAt !== "") {
      obj.created_at = message.createdAt;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ApiPaymentLinkItem.toJSON(e));
    }
    return obj;
  },
};

export const ApiPaymentLink: MessageFns<ApiPaymentLink> = {
  fromJSON(object: any): ApiPaymentLink {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      attributes: isSet(object.attributes) ? ApiPaymentLinkAttributes.fromJSON(object.attributes) : null,
    };
  },

  toJSON(message: ApiPaymentLink): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.attributes !== undefined && message.attributes !== null) {
      obj.attributes = ApiPaymentLinkAttributes.toJSON(message.attributes);
    }
    return obj;
  },
};

export const ApiMeta: MessageFns<ApiMeta> = {
  fromJSON(object: any): ApiMeta {
    return {
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      totalCount: isSet(object.total_count) ? globalThis.Number(object.total_count) : 0,
      nextPage: isSet(object.next_page) ? globalThis.Number(object.next_page) : 0,
      prevPage: isSet(object.prev_page) ? globalThis.Number(object.prev_page) : 0,
      totalPages: isSet(object.total_pages) ? globalThis.Number(object.total_pages) : 0,
      currentPage: isSet(object.current_page) ? globalThis.Number(object.current_page) : 0,
      perPage: isSet(object.per_page) ? globalThis.Number(object.per_page) : 0,
    };
  },

  toJSON(message: ApiMeta): unknown {
    const obj: any = {};
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    if (message.totalCount !== 0) {
      obj.total_count = Math.round(message.totalCount);
    }
    if (message.nextPage !== 0) {
      obj.next_page = Math.round(message.nextPage);
    }
    if (message.prevPage !== 0) {
      obj.prev_page = Math.round(message.prevPage);
    }
    if (message.totalPages !== 0) {
      obj.total_pages = Math.round(message.totalPages);
    }
    if (message.currentPage !== 0) {
      obj.current_page = Math.round(message.currentPage);
    }
    if (message.perPage !== 0) {
      obj.per_page = Math.round(message.perPage);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
